import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TimeSelect from './seat/TimeSelect';
import SeatSelect from './seat/SeatSelect';
import SeatInfoDialog from './seat/SeatInfoDialog';
import Bill from './seat/Bill';
import HowPayDialog from './seat/HowPayDialog';
import { fetchDefault } from './Utils.js';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import SeatChart from './SeatChart';

const useStyles = makeStyles(theme => ({
    paper: {
        width: '100%',
        marginTop: 1,
        overflowX: 'auto',
    },
    DateTextField: {
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        width: 280,
    },
    currentPrepaidTime: {
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        width: 180,
    },
    seatButton: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}));

export default function OccupySeat() {
    const classes = useStyles();

    const [time, setTime] = React.useState();
    const [seat, setSeat] = React.useState();
    const [seatList, setSeatList] = React.useState([]);



    const [originalPrice, setOriginalPricet] = React.useState();
    const [memberDiscount, setMemberDiscount] = React.useState();
    const [usePoint, setUsePoint] = React.useState();
    const [myPoint, setMyPoint] = React.useState();
    const [totalPrice, setTotalPrice] = React.useState();

    const [currentPrepaidTime, setCurrentPrepaidTime] = React.useState();
    const [currentMonthly, setCurrentMonthly] = React.useState();


    const [seatMap, setSeatMap] = React.useState(false);
    const [seatChart, setSeatChart] = React.useState(false);
    const [allReserveList, setAllReserveList] = React.useState([]);

    const [monthlyList, setMonthlyList] = React.useState();

    const onTimeChanged = (t) => {
        setTime(t);

        //테이블 리스트
        fetchDefault('/Payment/GetAvailableSeatList?startDateTime=&time=' + t,
            (data) => {
                setSeatList([data][0]);
                //setSeat([data][0][0].id);
            }
        );

        //계산
        setBill(t, seat);
    };

    const onTableChanged = (tableId) => {
        setSeat(tableId);

        //계산
        setBill(time, tableId);
    };

    useEffect(() => {

        //테이블 리스트
        /*
        fetchDefault('/Payment/GetAvailableSeatList?startDateTime=&time=240&isRoom=false&isDefaultTime=true',
            (data) => {

                //이용시간 60으로 변경해서 한번 더
                if (data.length === 0) {
                    setTime(60);
                    fetchDefault('/Payment/GetAvailableSeatList?startDateTime=&time=60',
                        (data) => {
                            setSeatList([data][0]);
                            if ([data][0][0].id) {
                                setSeat([data][0][0].id);

                                //계산
                                setBill(time, [data][0][0].id);
                            }
                        }
                    );
                }
                else {

                    setSeatList([data][0]);
                    if ([data][0][0].id) {
                        setSeat([data][0][0].id);

                        //계산
                        setBill(time, [data][0][0].id);
                    }

                }
            }
        );
        */

        //월정액
        fetchDefault('/Payment/GetCurrentMonthly',
            (data) => {
                if (data.endDateTime) {
                    setCurrentMonthly(data.endDateTime.substring(0, 16));
                }
            }
        );

        fetchDefault('/Payment/GetMonthlyList',
            (data) => {
                setMonthlyList(data);
            }
        );

        //시간정액
        fetchDefault('/Payment/GetCurrentPrepaid',
            (data) => {
                setCurrentPrepaidTime(data.time);
            }
        );

        return () => {
        }
    }, []);

    const setBill = (time, tableId) => {
        fetchDefault('/Payment/GetBill?startDateTime=&time=' + time + '&tableId=' + tableId,
            (data) => {
                setOriginalPricet(data.originalPrice);
                setMemberDiscount(data.memberDiscount);
                setUsePoint(data.usePoint);
                setTotalPrice(data.totalPrice);
                setMyPoint(data.myPoint);
            }
        );

    }


    //예약된 전체 자리 보기
    const GetAllSeatInfo = () => {
        
        fetchDefault('/Seat/GetAllSeatUseInfo',
            (data) => {
                setAllReserveList(data);
                setSeatMap(true);
            }
        );
    }

    const GetAllSeatChart = () => {
        setSeatChart(true);
    }


    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h2>자리 이용하기</h2>
                </Grid>

                {currentMonthly ? (
                    <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                <Typography variant="body1">
                                    실제 이용 시간만 예약해 주세요. 3시간 이상 빈자리일 경우 모든 예약이 자동 취소됩니다.
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ) : (<div></div>)}

                
                <Grid item xs={12}>
                    <Typography variant="h6">
                        1. 이용시간을 선택해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TimeSelect time={time} onTimeChanged={onTimeChanged} />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        2. 이용을 원하시는 자리를 선택해주세요.
                    </Typography>

                    <Typography variant="body2">
                        (카페를 둘러보시고, 주변에 있는 자리번호를 확인하세요.)
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <SeatSelect tableList={seatList} seat={seat} onTableChanged={onTableChanged} />
                    {/*<SeatInfoDialog onTableChanged={onTableChanged} time={time} />*/}
                </Grid>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <img alt="loading..." src={require('../images/seats_v1.0.png')} style={{ width: 650 }} />
                    </Paper>
                    <Button className={classes.seatButton} variant="outlined" onClick={GetAllSeatChart}>
                        예약 현황표
                    </Button>
                    <Button className={classes.seatButton} variant="outlined" onClick={GetAllSeatInfo}>
                        예약 전체 보기
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        3. 결제를 진행해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Bill originalPrice={originalPrice} memberDiscount={memberDiscount} usePoint={usePoint} myPoint={myPoint}  totalPrice={totalPrice} />
                </Grid>

                {currentMonthly ? (
                    <Grid item xs={12}>
                    <TextField
                        id="currentMonthly"
                        label="현재 월정액 종료날짜"
                        readonly
                        className={classes.DateTextField}
                        type="datetime-local"
                        value={currentMonthly}
                        />
                    </Grid>
                ) : (<div></div>)}

                {monthlyList ? (
                    <Grid item xs={12}>
                        {monthlyList.map(monthly => (
                            <Card style={{ marginBottom: 5 }}>
                                <CardContent>
                                    <Typography variant="body1">
                                        월정액 시작 : {monthly.startDateTime}
                                    </Typography>
                                    <Typography variant="body1">
                                        월정액 종료 : {monthly.endDateTime}
                                    </Typography>
                                </CardContent>
                            </Card>
                        ))}
                    </Grid>
                ) : (<Grid></Grid>)}
             

                
                {currentPrepaidTime > 0 ? (
                    <Grid item xs={12}>
                        <TextField
                            id="currentTime"
                            label="현재 정액권 남은 시간"
                            readonly
                            className={classes.currentPrepaidTime}
                            variant="outlined"
                            value={Math.floor(currentPrepaidTime / 60) + '시간' + currentPrepaidTime % 60 + '분'}
                        />
                    </Grid>
                ) : (<div></div>)}
               

                <Grid item xs={12}>
                    <HowPayDialog usePoint={usePoint} totalPrice={totalPrice} controllerUrl={'/Payment/UseSeat?startDateTIme=&time=' + time + '&seat=' + seat} />
                </Grid>
            </Grid>




            <Dialog
                fullWidth='true'
                maxWidth='md'
                open={seatMap}
                onClose={() => { setSeatMap(false) }}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    {allReserveList.map(seat => (
                        <Card style={{ marginBottom: 5 }}>
                            <CardContent>
                                <Typography variant="h6">
                                    {seat.tableName}
                                </Typography>
                                <Typography variant="body1">
                                    {
                                        seat.time.split('/').map(t => {
                                            return <div style={{ marginBottom: 14, marginTop: 14 }}>{
                                                t.split('|').map(a => {
                                                    return <div>{a}</div>;
                                                })
                                            }</div>;

                                        })
                                    }
                                </Typography>
                            </CardContent>
                        </Card>
                    ))}

                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setSeatMap(false)}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                fullWidth='true'
                maxWidth='md'
                open={seatChart}
                onClose={() => { setSeatChart(false) }}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <SeatChart />
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setSeatChart(false)}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>


        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/OccupySeat.js